import React from 'react'

function TermsAndConditions() {
  return (
    <div>
       <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Terms and Conditions</h1>
      <p><strong>Last updated: 22 April 2025</strong></p>

      <p>
        Welcome to **AHH International**! By accessing or using our website, you agree to comply with and be bound by the following terms and conditions.
      </p>

      <h3>1. Acceptance of Terms</h3>
      <p>By accessing and using our website, you accept and agree to abide by these Terms and Conditions and our Privacy Policy.</p>

      <h3>2. Use of Website</h3>
      <p>You are granted a limited, non-exclusive, non-transferable license to use our website for personal or business purposes. You must not use the website for any unlawful activity.</p>

      <h3>3. Product Information</h3>
      <p>We make every effort to ensure that the information on our website is accurate, but we do not guarantee the accuracy, completeness, or reliability of any content. Prices and availability are subject to change without notice.</p>

      <h3>4. Orders and Payment</h3>
      <p>When you place an order, you agree to pay for the products and services in full. All transactions are processed through secure third-party payment gateways.</p>

      <h3>5. Shipping and Delivery</h3>
      <p>We will process and ship your order as per the specified delivery timelines. However, we are not liable for delays caused by external factors such as weather, customs, or transportation issues.</p>

      <h3>6. Returns and Refunds</h3>
      <p>For returns and refunds, please refer to our <a href="/refund-policy">Refund Policy</a> page.</p>

      <h3>7. User Responsibilities</h3>
      <p>You agree to provide accurate and complete information when using our website, and not to engage in any activity that could harm our website or its users.</p>

      <h3>8. Limitation of Liability</h3>
      <p>We are not liable for any direct, indirect, incidental, or consequential damages arising from the use of our website, products, or services.</p>

      <h3>9. Changes to Terms</h3>
      <p>We may update these Terms and Conditions from time to time. Any changes will be posted on this page, and the "last updated" date will be revised accordingly.</p>

      <h3>10. Governing Law</h3>
      <p>These Terms and Conditions are governed by and construed in accordance with the laws of Pakistan. Any disputes will be resolved within the jurisdiction of Pakistani courts.</p>

      <h3>11. Contact Us</h3>
      <p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
      <p>📧 Email: support@ahhinternational.com</p>
      <p>📞 Phone: +92 300 1234567</p>
      <p>📍 Address: Head Office, Kamirwala, Pakistan</p>
    </div>
    </div>
  )
}

export default TermsAndConditions
